import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  showSuccessDialog,
  showErrorDialog,
  StatusFormatter,
  StatusCrpFormatter,
  sizePerPageList,
  showDialog,
  useForceUpdate,
} from "../../../../utility";
import Select from "react-select";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectReasonParam,
  fetchReasonParam,
  fetchMaterial,
  selectDataMaterial,
  selectDraft,
  uploadFile,
  editDraft,
} from "./nonRefSlice";
import LoadingFetchData from "../LoadingFetchData";
import InputNumber from "./../InputNumber";

import DeleteIcon from "@material-ui/icons/Delete";
import ImageIcon from "@material-ui/icons/Image";
import moment from "moment";

export const DraftNonRef = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const reasonParam = useSelector(selectReasonParam);
  const data = useSelector(selectData);
  const dataMaterial = useSelector(selectDataMaterial);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataDraft = useSelector(selectDraft);



  // Add status field to prevent object is not extensible error
  const initData = dataDraft.map((item, index) => ({
    ...item,
    no: index + 1,
    returnUom: item.uom,
  }));

  // const [tableData, setTableDataDraft] = useState(initData);
  const [reasonCode, setReasonCode] = useState("");
  const [selectCustomer, setSelectCustomer] = useState([]);
  const [tableData, setTableData] = useState(initData);
  const [remark, setRemark] = useState("");
  const [requestDate, setRequestDate] = useState("");
  const forceUpdate = useForceUpdate();
  
  if (tableData === null) {
    history.push("/report-return/report-header");
  }
  useEffect(() => {
    // Fetch data on first load
    dispatch(
      fetchReasonParam({
        paramGroupId: "REASON",
        pageNo: 1,
        pageSize: 20,
      })
    );
    setReasonCode(dataDraft[0].reasonCode);
  }, [dispatch]);

  //checker rowRemark
  const checkValue = (value) => {
    let remarkRow = "";
    if (value.customerBlocked === true) {
      remarkRow = "Customer Block.";
    } else if (value.batchStatus === false) {
      remarkRow = "Invalid Batch Number, Please Contact PAM";
    } else if (value.blocked === true) {
      remarkRow = "Material Block. Please Contact PAM";
    } else if (value.materialExcluded === true) {
      remarkRow = "Material Block Exclusion. Please Contact PAM";
    } else if (value.crprgp === "N/A") {
      remarkRow = "CRRGP Block. Please Contact NDC RG Team";
    } else {
      remarkRow = "";
    }
    return remarkRow;
  };

  //
  const [tableDataMaterial, setTableDataMaterial] = useState(dataMaterial);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);

    const initData = dataMaterial.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
        blockRemark: checkValue(item),
      };
    });
    setTableDataMaterial(initData);
  }, [dataMaterial, pageSize, pageNo]);

  const reasonOptions = reasonParam.map((e) => {
    return {
      value: e.paramCode,
      label: e.paramValue,
    };
  });

  const getValueReason = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  // Modal Material
  const [showMaterial, setShowMaterial] = useState(false);
  const [materialCode, setMaterialCode] = useState("");
  const [batch, setBatch] = useState("");
  const handleCloseMaterial = () => setShowMaterial(setSelectCustomer);
  const handleShowMaterial = () => setShowMaterial(true);
  const [onSelectAll, setOnSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const [overlayStateMaterial, setOverlayStateMaterial] = React.useState(false);

  const [showResultsMaterial, setShowResultsMaterial] = React.useState(false);

  let notSelectableRows = [];

  const getNonSelectableRows = (payload) => {
    let nonSelectable = [];
    payload.map((value, index) => {
      if (value.customerBlocked === true) {
        nonSelectable.push(index);
      } else if (value.batchStatus === false) {
        nonSelectable.push(index);
      } else if (value.blocked === true) {
        nonSelectable.push(index);
      } else if (value.materialExcluded === true) {
        nonSelectable.push(index);
      } else if (value.crprgp === "N/A") {
        nonSelectable.push(index);
      }
    });

    return nonSelectable;
  };

  notSelectableRows = getNonSelectableRows(tableDataMaterial);

  const onSelectRow = {
    clickToSelect: true,
    mode: "checkbox",
    hideSelectAll: notSelectableRows.length > 0 ? true : false,
    nonSelectable: notSelectableRows,
    nonSelectableStyle: { backgroundColor: "gray" },
    onSelectAll: (status) => {
      setOnSelectAll(status);
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
          setSelectedRows(selectedRows);
        }
      }
      // return selectedRows;
    },
  };

  const rowClasses = (row, rowIndex) => {
    let classes = null;

    if (notSelectableRows.includes(rowIndex)) {
      classes = "disabled-row-table";
    } else {
      classes = "enable-row-table";
    }

    return classes;
  };

  console.log(tableData, "test");

  const handleDeleteRow = (column) => {
    const idColumn = column.returnDetailId;

    let tableDataNew = tableData.filter(
      (value, index) => value.returnDetailId !== idColumn
    );

    setSelectedRows(tableDataNew);
    setTableData(tableDataNew);
    forceUpdate();
  };

  const handleDeleteChangeData = (column) => {
    const idColumn = column.returnDetailId;
    setUid(idColumn);
  };

  const [uid, setUid] = useState("");

  useEffect(() => {
    handleDeleteRow(uid, dataDraft);
  }, [uid]);

  const updateTableDataFromMaterialTable = () => {
    let tableDataNew = tableData;

    setTableData(selectedRows);
    setShowMaterial(false);
    forceUpdate();
  };

  const handleSearchMaterial = async () => {
    let valid = false;
    if (materialCode === "" && batch !== "") {
      valid = true;
    } else if (batch === "" && materialCode !== "") {
      valid = true;
    } else if (batch !== "" && materialCode !== "") {
      valid = true;
    }

    if (!valid) {
      return showDialog("Please Insert Material or Batch Code First!");
    }
    setOverlayStateMaterial(true);
    const params = {
      customerCode: tableData[0].customerCode,
      customerName: tableData[0].customerName,
      distributionChannel: tableData[0].distributionChannel,
      materialCode: materialCode,
      batch: batch,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    await dispatch(fetchMaterial(params));
    setOverlayStateMaterial(false);
    setShowResultsMaterial(true);
  };

  const handleTableChangeMaterial = async (type, { page, sizePerPage }) => {
    setOverlayStateMaterial(true);

    const params = {
      customerCode: tableData[0].customerCode,
      customerName: tableData[0].customerName,
      distributionChannel: tableData[0].distributionChannel,
      materialCode: materialCode,
      batch: batch,
      pageNo: page,
      pageSize: sizePerPage,
    };
    await dispatch(fetchMaterial(params));
    setOverlayStateMaterial(false);
  };
  const optionsMaterial = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  // end modal material

  const [rowIndexTable, setRowIndexTable] = useState(null);

  // function Remark
  const handleRemarkRowChange = (e, row, rowIndex, formatExtraData) => {
    formatExtraData[rowIndex].remarkRow = e.target.value;
    setTableData(formatExtraData);
  };

  const remarkFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <Form.Control
          className={`remark-brqa`}
          as="textarea"
          placeholder="Leave a comment here"
          style={{ height: "80px" }}
          onChange={(e) =>
            handleRemarkRowChange(e, row, rowIndex, formatExtraData)
          }
          maxLength={255}
        />
      </div>
    );
  };

  // const [docData, setDocData] = useState([]);

  const handleUpload = async (e, rowIndex, row, cell, formatExtraData) => {
    const file = e.target.files[0];
    const params = {
      file: file,
    };
    try {
      const response = await dispatch(uploadFile(params));
      if (response.payload.status === 200) {
        // const action = await showSuccessDialog(response.payload.data);

        const temp = tableData;
        temp[rowIndex].attachmentId = response.payload.data;
        temp[rowIndex].filename = file.name;
        setTableData(temp);
        forceUpdate();
      }
    } catch (error) {
      console.log(error);
      showErrorDialog("Something went wrong!");
    }
  };

  const handleDeleteFile = async (e, rowIndex) => {
    const temp = tableData;
    temp[rowIndex].attachmentId = null;
    temp[rowIndex].filename = null;
    forceUpdate();
  };

  // function Upload

  const uploadFormatter = (cell, row, rowIndex, formatExtraData) => {
    let render = (
      <div>
        <input
          type="file"
          onChange={(e) =>
            handleUpload(e, rowIndex, row, cell, formatExtraData)
          }
          style={{ color: "transparent", width: "91px" }}
          // accept="image/*"
          accept="image/png, image/gif, image/jpeg"
        />
      </div>
    );

    if (row.attachmentId) {
      render = (
        <div className="filename-container">
          <div className="div-filename">{row.filename}</div>
          <a
            href={`${process.env.REACT_APP_API_URL}/return/attachment/${row.attachmentId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ImageIcon style={{ color: "#648DAE", marginRight: "5px" }} />
          </a>
          <DeleteIcon
            onClick={(e) => handleDeleteFile(e, rowIndex, formatExtraData)}
          />
        </div>
      );
    }

    if (formatExtraData.reasonCode == "132") {
      render = "cannot upload";
    }

    return render;
  };

  const handleInputQtyChange = async (e, row, rowIndex, formatExtraData) => {
    formatExtraData[rowIndex].qty = e.target.value;
    setTableData(formatExtraData);
  };

  const inputQtyFormmater = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Form.Control
        type="number"
        step="any"
        className="remark-brqa"
        defaultValue="1"
        value={row.qty}
      />
    );
  };

  // UOM Render
  const getValueUom = (value, options) => {
    console.log(options.filter((val) => value === val.label));
    return options.filter((val) => value === val.label);
  };

  const handleUomValueChange = async (
    e,
    row,
    rowIndex,
    options,
    formatExtraData
  ) => {
    const selected = options.filter((val) => e.value === val.label);

    const uom = selected[0];
    formatExtraData[rowIndex].returnUom = e.value;
    formatExtraData[rowIndex].qty =
      (formatExtraData[rowIndex].qty / uom.numerator) * uom.denumerator;
    setTableData(formatExtraData);
    forceUpdate();
  };

  const renderUom = (cell, row, rowIndex, formatExtraData) => {
    const alt_uom = row.altUom;
    let cell_uom = cell;
    const options_this = [
      { value: "", label: "", numerator: "", denumerator: "" },
    ];

    alt_uom.map((value, index) => {
      options_this.push({
        value: value.uom,
        label: value.uom,
        numerator: value.numerator,
        denumerator: value.denumerator,
      });
    });

    return (
      <Select
        isSearchable={false}
        className="uom-select"
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        key={`uom-${rowIndex}`}
        options={options_this}
        onChange={(e) =>
          handleUomValueChange(e, row, rowIndex, options_this, formatExtraData)
        }
        value={getValueUom(cell_uom, options_this)}
      />
    );
  };

  const handleDraft = () => {
    // Setup Request Body Params
    tableData.map((value) => {
      if (reasonCode === "132") {
        value.sloc = "B41";
      } else if (reasonCode === "135") {
        value.sloc = "B42";
      }
      if (value.returnUom) {
      } else {
        value.returnUom = value.uom;
      }
    });
    const items = tableData.map((e) => {
      return {
        attachmentId: e.attachmentId,
        batch: e.batch,
        clientCode: e.clientCode,
        clientName: e.clientName,
        crprgp: e.crprgp,
        expiredDate: e.expiredDate,
        materialCode: e.materialCode,
        materialName: e.materialName,
        materialRemarks: e.materialRemarks,
        netPrice: e.netPrice,
        nra: e.nra,
        qty: e.qty,
        returnUom: e.returnUom,
        sloc: e.sloc,
        uom: e.uom,
        remark: e.remarkRow,
        rayonType: e.rayonType,
        line: e.line,
      };
    });
    const id = tableData[0].returnId;

    const params = {
      customerCode: tableData[0].customerCode.toString(),
      customerCodeOrigin: tableData[0].customerCodeOrigin,
      distributionChannel: tableData[0].distributionChannel,
      plantCode: tableData[0].plantCode.toString(),
      reasonCode: reasonCode,
      transactionDate: moment(tableData[0].transactionDate).format(
        "YYYY-MM-DD"
      ),
      po: tableData[0].po,
      dataSource: "NONREF",
      returnType: "NOREFNONMTKA",
      remark: remark,
      customerPODate: requestDate,
      draft: true,
      items: items,
    };
    console.log(params, "params");
    callApi({ params, id });
  };

  const handleSave = () => {
    //checking attachment
    const attachmentChecker = [];
    tableData.map((val, index) => {
      if (val.attachmentId) {
      } else {
        attachmentChecker.push(index);
      }
    });

    if (reasonCode !== "132" && attachmentChecker.length > 0) {
      return showErrorDialog("Please Upload Image !");
    }

    if (reasonCode === "") {
      return showErrorDialog("Please Select Reason First !");
    }
    // Setup Request Body Params
    tableData.map((value) => {
      if (reasonCode === "132") {
        value.sloc = "B41";
      } else if (reasonCode === "135") {
        value.sloc = "B42";
      }
      if (value.returnUom) {
      } else {
        value.returnUom = value.uom;
      }
    });
    const items = tableData.map((e) => {
      return {
        attachmentId: e.attachmentId,
        batch: e.batch,
        clientCode: e.clientCode,
        clientName: e.clientName,
        crprgp: e.crprgp,
        expiredDate: e.expiredDate,
        materialCode: e.materialCode,
        materialName: e.materialName,
        materialRemarks: e.materialRemarks,
        netPrice: e.netPrice,
        nra: e.nra,
        qty: e.qty,
        returnUom: e.returnUom,
        sloc: e.sloc,
        uom: e.uom,
        remark: e.remarkRow,
        rayonType: e.rayonType,
        line: e.line,
      };
    });
    const id = tableData[0].returnId;

    const params = {
      customerCode: tableData[0].customerCode.toString(),
      customerCodeOrigin: tableData[0].customerCodeOrigin,
      distributionChannel: tableData[0].distributionChannel,
      plantCode: tableData[0].plantCode.toString(),
      reasonCode: reasonCode,
      transactionDate: moment(tableData[0].transactionDate).format(
        "YYYY-MM-DD"
      ),
      po: tableData[0].po,
      dataSource: "NONREF",
      returnType: "NOREFNONMTKA",
      remark: remark,
      customerPODate: requestDate,
      draft: false,
      items: items,
    };
    console.log(params, "params");
    callApi({ params, id });
  };

  const callApi = async ({ params, id }) => {
    try {
      const response = await dispatch(editDraft({ params, id }));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(
          "Data has been saved!",
          `Return have been Saved, your return number : <strong>${response.payload.data.retNumber}</strong>`
        );
        if (action.isConfirmed) history.push("/new-return/non-rtv");
      }
    } catch (error) {
      console.log("error", error);
      showErrorDialog("Something went wrong!");
    }
  };

  const options = {
    showTotal: true,
    totalSize: tableData.length,
    sizePerPageList: sizePerPageList,
  };
  const columnsMaterial = [
    { text: "uuid", dataField: "uuid", hidden: true },
    { text: "No", dataField: "no" },
    { text: "Material Code", dataField: "materialCode" },
    { text: "Material Name", dataField: "materialName" },
    { text: "Uom", dataField: "uom", align: "center" },
    {
      text: "Batch",
      dataField: "batch",
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      formatter: formatDate,
      align: "center",
    },
    {
      text: "Material Block",
      dataField: "blocked",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "Material Exclusion",
      dataField: "materialExcluded",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "CRPRGP",
      dataField: "crprgp",
      align: "center",
      formatter: StatusCrpFormatter,
    },
    {
      text: "NRA",
      dataField: "nra",
      formatter: StatusFormatter,
      align: "center",
    },

    {
      text: "Block Remarks",
      dataField: "blockRemark",
    },
  ];
  const columnsData = [
    // {
    //   text: "Action",
    //   dataField: "action",
    //   editable: false,

    //   formatter: (cell, column, formatExtraData) => {
    //     return (
    //       <OverlayTrigger
    //         overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
    //       >
    //         <div
    //           className="btn btn-icon btn-light btn-hover-danger btn-sm"
    //           onClick={() => handleDeleteRow(column, cell)}
    //         >
    //           <span className="svg-icon svg-icon-md svg-icon-danger">
    //             <SVG
    //               src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
    //             />
    //           </span>
    //         </div>
    //       </OverlayTrigger>
    //     );
    //   },
    // },
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      editable: false,
      headerSortingClasses,
    },
    {
      text: "Material",
      dataField: "materialCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Batch",
      dataField: "batch",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDate,
      editable: false,
    },
    {
      text: "NRA",
      dataField: "nra",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: StatusFormatter,
      editable: false,
    },
    {
      text: "Uom",
      dataField: "returnUom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: renderUom,
      formatExtraData: tableData,
      editable: false,
    },
    {
      text: "Return Qty",
      dataField: "qty",
      sort: true,
      type: "number",
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: inputQtyFormmater,
      editorRenderer: (
        editorProps,
        value,
        row,
        column,
        rowIndex,
        columnIndex
      ) => {
        return <InputNumber {...editorProps} value={value} />;
      },
      formatExtraData: tableData,
    },
    {
      text: "Photo Product",
      dataField: "attachmentId",
      editable: false,
      formatter: (cell, row, rowIndex, formatExtraData) =>
        uploadFormatter(cell, row, rowIndex, formatExtraData),
      formatExtraData: {
        reasonCode: reasonCode,
        tableData: tableData,
      },
    },
    {
      text: "Remark",
      dataField: "remarkRow",
      formatter: remarkFormatter,
      formatExtraData: tableData,
      editable: false,
    },
  ];

  return tableData.length > 0 ? (
    <>
      <Card>
        <CardHeader title="Draft Non Reference"></CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      Customer Code <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={tableData[0].customerCode}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Name</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={tableData[0].customerName}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Distribution Channel</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={tableData[0].distributionChannel}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Plant Code</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={tableData[0].plantCode}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Reason</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Select
                      options={reasonOptions}
                      value={getValueReason(reasonCode, reasonOptions)}
                      placeholder="Select Reason..."
                      onChange={(e) => {
                        setReasonCode(e.value);
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Request Date</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="date"
                      onChange={(e) => {
                        setRequestDate(e.target.value);

                        forceUpdate();
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Remark</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      as="textarea"
                      onChange={(e) => {
                        setRemark(e.target.value);
                      }}
                      placeholder="Leave a comment here"
                      maxLength={35}
                      style={{ height: "100px" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>

            {/* <Row>
              <Col md="6" sm="6" lg="8">
                <Button
                  variant="primary"
                  className={`mr-5 mb-5`}
                  onClick={handleShowMaterial}
                >
                  Add Material
                </Button>
              </Col>
            </Row> */}
          </Form>

          {/* Table Add Material*/}
          {tableData.length > 0 && (
            <BootstrapTable
              remote
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              keyField="returnDetailId"
              data={tableData}
              columns={columnsData}
              pagination={paginationFactory(optionsMaterial)}
              hover
            />
          )}

          {/* Footer */}
          <Form>
            <Row>
              <Col md="6" sm="6" lg="8">
                <Button
                  variant="primary"
                  className="mr-5"
                  onClick={handleDraft}
                >
                  Draft
                </Button>
                <Button variant="success" className="mr-5" onClick={handleSave}>
                  Save
                </Button>
                <Button
                  variant="secondary"
                  className="mr-5"
                  onClick={() => history.push("/new-return/non-rtv")}
                >
                  Back
                </Button>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>

      {/* Add Material */}

      <Modal show={showMaterial} onHide={handleCloseMaterial} size="lg">
        <LoadingFetchData active={overlayStateMaterial} />
        <Modal.Header closeButton>
          <Modal.Title>Material Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      onChange={(e) => {
                        setMaterialCode(e.target.value);
                      }}
                      value={materialCode}
                      required
                      type="text"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Batch</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setBatch(e.target.value);
                      }}
                      value={batch}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control required type="text" />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>

            <Button
              className="mb-5"
              variant="secondary"
              onClick={handleSearchMaterial}
            >
              Search
            </Button>
          </Form>
          {showResultsMaterial > 0 && (
            <BootstrapTable
              remote
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              keyField="uuid"
              data={tableDataMaterial}
              columns={columnsMaterial}
              pagination={paginationFactory(optionsMaterial)}
              onTableChange={handleTableChangeMaterial}
              selectRow={onSelectRow}
              rowClasses={rowClasses}
              hover
            />
          )}
        </Modal.Body>
        {showResultsMaterial > 0 && (
          <Modal.Footer>
            <Row className="mt-4">
              <Col>
                <Button
                  variant="success"
                  onClick={() => {
                    updateTableDataFromMaterialTable();
                  }}
                >
                  Choose
                </Button>
              </Col>
              <Col>
                <Button
                  variant="outline-danger"
                  onClick={() => history.push("/")}
                >
                  Back
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        )}
      </Modal>
      {/*)}*/}
    </>
  ) : null;
};
